// extracted by mini-css-extract-plugin
module.exports = {"errorBoundary":"ErrorBoundary_errorBoundary__1OJgo","image":"ErrorBoundary_image__3dd6s","errorText":"ErrorBoundary_errorText__2vzU1"};